import { useMemo } from 'react';
import styles from './PageSizeSelector.module.css';
import { useCompositionAdvancedOptionsContext } from 'features/compositions/context/CompositionAdvancedOptionsContext';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';

const PageSizeSelector = () => {
    const sizes = useMemo(() => [12, 24, 48, 96, 120], []);
    const { limit, setLimit, setLocalLimit, setPage, setLocalReverse, setPrevKey, setLocalQuery } = useCompositionAdvancedOptionsContext();
    const { loading } = useCompositionsContext();

    const handleClick = (size) => {
        if (loading) return;
        setPrevKey("");
        setPage(1);
        setLocalReverse(false);
        setLocalQuery({});
        setLimit(size);
        setLocalLimit(size);
    };

    return (
        <div className={styles.page_size_selector}>
            {sizes.map((size) => (
                <button
                    key={size}
                    className={Number(limit) === Number(size) ? styles.active : ''}
                    onClick={() => handleClick(size)}
                    disabled={loading}
                >
                    {size}
                </button>
            ))}
        </div>
    );
}

export default PageSizeSelector;
